import { Injectable } from "@angular/core";
import { databases, ID } from "../config/appwrite";
import { environment } from "src/environments/environment";
import { Query } from "appwrite";

@Injectable({
  providedIn: "root",
})
export class epsServices {
  private collectionId = "eps";
  private DATABASE_NAME = environment.databaseName;

  constructor() {}

  getEps() {
    return databases.listDocuments(this.DATABASE_NAME, this.collectionId, [
      Query.limit(10000),
    ]);
  }
}
